/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { settlingin_IndicatorDefinitionDTO } from '../models/settlingin_IndicatorDefinitionDTO';
import type { settlingin_UpdateIndicatorsRequest } from '../models/settlingin_UpdateIndicatorsRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SettlingInSettingsService {
    /**
     * Get settling-in indicator definitions
     * @returns settlingin_IndicatorDefinitionDTO OK
     * @throws ApiError
     */
    public static getApiV1SettingsSettlingInIndicators(): CancelablePromise<Array<settlingin_IndicatorDefinitionDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settings/settling-in/indicators',
        });
    }
    /**
     * Update settling-in indicator definitions
     * @param request Indicator definitions
     * @returns settlingin_IndicatorDefinitionDTO OK
     * @throws ApiError
     */
    public static putApiV1SettingsSettlingInIndicators(
        request: settlingin_UpdateIndicatorsRequest,
    ): CancelablePromise<Array<settlingin_IndicatorDefinitionDTO>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/settings/settling-in/indicators',
            body: request,
        });
    }
}
